/**
 * Resolves CSS/HTML text direction for a BCP 47 language tag.
 * Uses Intl.Locale.getTextInfo when available, with a small fallback list.
 */
export function getTextDirection(language: string | undefined | null): "rtl" | "ltr" {
    if (!language || typeof language !== "string") {
        return "ltr";
    }
    const tag = language.trim().replace(/_/g, "-");
    if (!tag) {
        return "ltr";
    }

    if (typeof Intl !== "undefined" && typeof (Intl as any).Locale === "function") {
        try {
            const Locale = (Intl as any).Locale;
            const locale = new Locale(tag);
            const textInfo =
                typeof locale.getTextInfo === "function" ? locale.getTextInfo() : locale.textInfo;
            if (textInfo?.direction === "rtl" || textInfo?.direction === "ltr") {
                return textInfo.direction;
            }
        } catch {
            // Invalid language tag; fall through to prefix heuristic.
        }
    }

    const primary = tag.split("-")[0].toLowerCase();
    const rtlPrimaries = new Set([
        "ar",
        "arc",
        "dv",
        "fa",
        "he",
        "iw",
        "ku",
        "ps",
        "sd",
        "ug",
        "ur",
        "yi",
    ]);
    return rtlPrimaries.has(primary) ? "rtl" : "ltr";
}
